export type Role = "Admin" | "Manager" | "Normal";



export interface AuthInfo {
	name: string
	role: Role
}



export interface User {
	id: string
	name: string
	email: string
	role: Role
}



export interface DictionaryGroup {
	id: number
	name: string
	dictionaries: Dictionary[]
}

export interface Dictionary {
	id: number
	name: string
	dictionaryGroupId: number
	count: number
}



export interface IndexWord {
	id: number
	term: string
	updatedWhen: Date
	deleteChecked: boolean
}



export interface Word {
	id: number
	version: number
	term: string
	description: string
	dictionary: string
	dictionaryId: number
	dictionaryGroup: string
	updatedWhen: Date
	registrant: string
	updater: string
}



export enum SearchLocationType {
	Term,
	Description,
	Both
}

export enum SearchPositionType {
	StartsWith,
	Contains
}

export interface SearchQuery {
	searchKeyword: string
	dictionaryGroupIds: number[]
	searchLocationType: SearchLocationType
	searchPositionType: SearchPositionType
}